export default{
    form: (unit) => {
        return {
            name: "Krijo Njesi",
            submit: {
                label: "Krijo",
                action: 'submitUnit'
            },
            fields: [
                [
                    {
                        value: unit.name,
                        name: 'name',
                        label: 'Emri',
                        type: 'text-field',
                        style: 'flex-grow: 1',
                        required: true,
                        required_text: 'Kjo fushe eshte e detyrueshme'
                    },
                ],
            ]
        }
    }
}